<template>
    <breadCrumbs title="Product Page" main="Ecommerce" title1="Product Page" />
    <div class="container-fluid">
        <div>
            <div class="row product-page-main p-0">
                <productSwiper />
                <productDetails />
                <filterBlock />
            </div>
        </div>
        <productTab />
    </div>
</template>

<script>
import productSwiper from "./productSwiper.vue"
import productDetails from "./productDetails.vue"
import filterBlock from "./filterBlock.vue"
import productTab from "./productTab.vue"
export default {
    name: "productPage",
    data() {
        return {
            counter: 1,
            modalShow: false,
            activeTab: 'fabric',
        }
    },
    components: {
        productSwiper, productDetails, filterBlock, productTab
    },
}
</script>